// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json = require("../../shared/src/Json.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Plaid = require("../../shared/src/bindings/Plaid.bs.js");
var Js_exn = require("bs-platform/lib/js/js_exn.js");
var GoogleApi = require("../../shared/src/bindings/GoogleApi.bs.js");
var CommonTypes = require("../../shared/src/types/CommonTypes.bs.js");
var StripeTypes = require("../../shared/src/bindings/StripeTypes.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");

function decode(param) {
  return Curry._2(Json.Decode.$less$star$great, Curry._2(Json.Decode.$less$star$great, Curry._2(Json.Decode.$less$star$great, Curry._2(Json.Decode.$less$star$great, Curry._2(Json.Decode.$less$star$great, Curry._2(Json.Decode.$less$star$great, Curry._2(Json.Decode.$less$$great, (function (apiUrl, deployEnv, googleMapsWebClientApiToken, plaidEnv, plaidPublicKey, stripeApiKey, version) {
                                        return {
                                                apiUrl: apiUrl,
                                                deployEnv: deployEnv,
                                                googleMapsWebClientApiToken: googleMapsWebClientApiToken,
                                                plaidEnv: plaidEnv,
                                                plaidPublicKey: plaidPublicKey,
                                                stripeApiKey: stripeApiKey,
                                                version: version
                                              };
                                      }), Curry._1(Json.Decode.string, process.env.API_URL)), Curry._2(Json.Decode.$less$pipe$great, Curry._1(CommonTypes.DeployEnv.decode, process.env.DEPLOY_ENV), Relude_Result.ok(/* Local */0))), Curry._1(GoogleApi.Token.decode, process.env.GOOGLE_MAPS_WEB_CLIENT_API_TOKEN)), Curry._1(Json.Decode.string, process.env.PLAID_ENV)), Curry._1(Plaid.Key.decode, process.env.PLAID_PUBLIC_KEY)), Curry._1(StripeTypes.PublicKey.decode, process.env.STRIPE_API_KEY)), Curry._2(Json.Decode.$less$pipe$great, Curry._1(CommonTypes.QwickClientVersion.decode, process.env.CI_COMMIT_SHA), Curry._1(CommonTypes.QwickClientVersion.decode, "unspecified")));
}

var error = Json.Decode.mapErrorToDebugString(decode(undefined));

var vars;

vars = error.TAG === /* Ok */0 ? error._0 : Js_exn.raiseError(error._0);

exports.vars = vars;
/* error Not a pure module */
